/**
 * @author        matthew@zumper.com (Matthew Talamini)
 * @copyright     Copyright (c) 2024, Zumper
 * @description   SupplementalContent bizos
 */

import { Bizo, autoclass } from './base'

import type {
  RawSupplementalContent,
  SupplementalContent as SupplementalContentType,
} from './supplementalContent.types'

const SUPPLEMENTAL_CONTENT_DEFINITION = {
  contentId: 'content_id',
  contentType: 'content_type',
  contentUrl: 'content_url',
  createdOn: 'created_on',
  description: 'description',
  descriptionTitle: 'description_title',
  keywords: 'keywords',
  lastGenerated: 'last_generated',
  modifiedOn: 'modified_on',
  propertyOverview: 'property_overview',
  reviewsSummary: 'reviews_summary',
  supplementalContentId: 'supplemental_content_id',
  version: 'version',
} as const

export const SupplementalContent: typeof SupplementalContentType = autoclass<
  SupplementalContentType,
  RawSupplementalContent
>(
  'SupplementalContent',
  class SupplementalContent extends Bizo<SupplementalContentType, RawSupplementalContent> {},
  SUPPLEMENTAL_CONTENT_DEFINITION,
  null
)
export type SupplementalContent = SupplementalContentType
